import { takeWindowData } from './takeWindowData';

// The device catalog (Settings, Wearables): base grades per device and metric, 0 to 100,
// 40 the alert floor. SOURCE: the Sep 16 copy the design ships as a script that sets
// window.DEVICE_CATALOG. Swapping in the new copy is this one import line.
import '../../../../design-preview/device-catalog-data.js';

/** [metric, grade 0-100] */
export type DeviceGrade = [string, number];
/** [name, logo file, 'connected' | ..., grades, note] */
export type DeviceRow = [string, string, string, DeviceGrade[], string];

export interface DeviceCatalog {
  floor: number;
  scaleNote: string;
  ceilingNote: string;
  bpRule: string;
  framing: string;
  groups: { g: string; note: string; devices: DeviceRow[] }[];
  trendOnly: { title: string; body: string; metrics: string[] };
  derate: { title: string; items: [string, string][] };
}

export const DEVICE_CATALOG: DeviceCatalog | null = takeWindowData<DeviceCatalog | null>('DEVICE_CATALOG', null);
